import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { SnackbarProvider } from 'notistack';
import { notistackDefaultAction } from 'utils/notistack';

import { DefaultSnackbar, UploadSnackbar, MoveSnackbar } from 'components/common/snackbar';

import { ArtworkDrawerProvider } from 'contexts/ArtworkDrawerContext';
import { ArtworkProvider } from 'contexts/ArtworkContext';
import { ConfirmDialogProvider } from 'contexts/ConfirmDialogContext';
import { InfoDialogProvider } from 'contexts/InfoDialogContext';
import { DrawerProvider } from 'contexts/DrawerContext';
import { FilePreviewDialogProvider } from 'contexts/FilePreviewDialogContext';

import { useCurrentUser } from 'hooks/useCurrentUser';

import WelcomeDialogHandler from 'components/common/WelcomeDialogHandler';
import { ArtworkRoutes, MainRoutes, RestrictedRoutes } from 'router/Routes';

import './styles.css';
import 'simplebar-react/dist/simplebar.min.css';

const AuthorizationController = ({ accountDetails }) => {
  useCurrentUser();

  const isRestricted = accountDetails?.accountStatus !== 'Active';

  return (
    <SnackbarProvider
      maxSnack={5}
      autoHideDuration={3000}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      action={notistackDefaultAction}
      dense
      Components={{
        default: DefaultSnackbar,
        upload: UploadSnackbar,
        move: MoveSnackbar,
      }}
      preventDuplicate
    >
      <InfoDialogProvider>
        <ConfirmDialogProvider>
          <FilePreviewDialogProvider>
            <DrawerProvider>
              <ArtworkDrawerProvider>
                <ArtworkProvider>
                  <WelcomeDialogHandler />
                  <RouterProvider
                    router={createBrowserRouter(isRestricted ? RestrictedRoutes : [MainRoutes, ArtworkRoutes])}
                  />
                </ArtworkProvider>
              </ArtworkDrawerProvider>
            </DrawerProvider>
          </FilePreviewDialogProvider>
        </ConfirmDialogProvider>
      </InfoDialogProvider>
    </SnackbarProvider>
  );
};

export default AuthorizationController;
